import { useMutation, useQueryClient } from 'react-query';
import api from 'api';
import type { UpdateOvertimeEntriesInput, OvertimeGetPreviewInput } from 'api/gql-utils/overtime/types';
import queryKeys from '../../queries';

export function useOvertimeMutations() {
  const queryClient = useQueryClient();

  const saveEntries = useMutation(
    (input: UpdateOvertimeEntriesInput) =>
      api.overtime.mutations.updateEntries({ input }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.OVERTIME_LIST_ENTRIES_KEY]);
      },
    },
  );

  const previewAmount = useMutation(
    (input: OvertimeGetPreviewInput) =>
      api.overtime.queries.getPreview({ input }),
  );

  return { saveEntries, previewAmount };
}
